<template>
  <div>
    <h1>Recherche FDES</h1>

    <div class="container input-container">
      <input type="number" v-model="idFdes" class="form-control" placeholder="ID FDES" />
      <button @click="loadDatas">Recherche</button>
    </div>

    <div class="container content fdes-content">
      <!-- Articles -->
      <div>
        <h2>Articles</h2>
        <vue-good-table :columns="columns"
                        :rows="articles"
                        :sort-options="{enabled: true}"
                        :pagination-options="{
                          enabled: true,
                          perPage: 15,
                          position: 'top',
                          perPageDropdown: [15, 25, 50, 100],
                          dropdownAllowAll: true,
                          firstLabel: 'Première page',
                          lastLabel: 'Dernière page',
                          nextLabel: 'Suivant',
                          prevLabel: 'Précédent',
                          rowsPerPageLabel: 'Articles par page',
                          ofLabel: 'sur',
                          pageLabel: 'page',
                          allLabel: 'Tous'
                        }"
                        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'Impact carbone sur 50 ans'">
              <span :class="{ 'leaf-green': parseFloat(props.row['Impact carbone sur 50 ans']) <= impactCarboneMedium, 'leaf-red': parseFloat(props.row['Impact carbone sur 50 ans']) > impactCarboneMedium }">
                <font-awesome-icon icon="leaf"></font-awesome-icon>
              </span>
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </template>
        </vue-good-table>
      </div>

      <!-- Fournisseurs -->
      <div class="frs-section">
        <h2>Fournisseurs</h2><small>(Classés par impact carbone croissant)</small>
        <br />
        <div class="frs-box-container">
          <div v-for="supplier in suppliers" class="frs-box" :key="supplier.SupplierCode">
            <div class="frs-ids">
              <div class="frs-initials">
                <h3>{{supplier.SupplierName.slice(0, 1).toUpperCase()}}</h3>
              </div>
              <div>
                <h3>{{ supplier.SupplierName }}</h3>
                <h4>{{ supplier.SupplierCode }}</h4>
              </div>
            </div>
            <div class="frs-datas">
              <div class="d-flex justify-content-between">
                <span>Impact carbone moyen fournisseur : </span>
                <span :class="{'leaf-green': supplier.MediumCarbonImpact <= impactCarboneMedium, 'leaf-red': supplier.MediumCarbonImpact > impactCarboneMedium}">{{ supplier.MediumCarbonImpact.toFixed(2) }}</span>
              </div>
              <div class="d-flex justify-content-between">
                <span>Impact carbone moyen global : </span>
                <span>{{ impactCarboneMedium.toFixed(2) }}</span>
              </div>
              <div class="d-flex justify-content-between">
                <span>Classification : </span>
                <span :class="{'leaf-green': supplier.MediumCarbonImpact <= impactCarboneMedium, 'leaf-red': supplier.MediumCarbonImpact > impactCarboneMedium}">
                  <font-awesome-icon icon="leaf"></font-awesome-icon>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { getFdesArticles } from "@/utils/bdoublewin";
  import { enumBdwFhStatut } from "@/enums/bdw/fhStatut";

  export default {
    name: "RechercheFdes",
    components: {},
    data() {
      return {
        articles: [],
        suppliers: [],
        impactCarboneMedium: 0,
        idFdes: null
      }
    },
    computed: {
      columns() {
        const res = [
          { label: "Référence", field: "Reference", filterOptions: { enabled: true, } },
          { label: "Désignation", field: "Name", filterOptions: { enabled: true, }, formatFn: this.convertFromHtmlEntities },
          { label: "", field: "Impact carbone sur 50 ans" },
          { label: "Fournisseur", field: "SupplierName", filterOptions: { enabled: true } },
          { label: "EAN", field: "Ean", filterOptions: { enabled: true } },
          { label: "FH Statut", field: "FHStatut", filterOptions: { enabled: true }, formatFn: (val) => enumBdwFhStatut[val] },
        ]

        return res;
      }
    },
    mounted() {
      // A passer dans le clic de la recherche
      this.loadDatas();

    },
    methods: {

      // Recherche par un ID FDES
      loadDatas() {
        getFdesArticles(this.idFdes || 0).then(e => {

          // Articles bruts
          this.articles = [];
          this.articles = e.map(art => ({
            ...art,
            "Impact carbone sur 50 ans": parseFloat(art["Impact carbone sur 50 ans"])
          }));

          // Groupe pour les fournisseurs
          let suppliers = [];
          e.forEach(art => {
            if (!suppliers.find(f => f.SupplierCode == art.SupplierCode)) {
              const frsArticles = e.filter(a => a.SupplierCode == art.SupplierCode);

              let supplier = {
                SupplierName: art.SupplierName,
                SupplierCode: art.SupplierCode,
                ArticleNumber: frsArticles.length,
                MediumCarbonImpact: frsArticles.reduce((acc, el) => acc + parseFloat(el['Impact carbone sur 50 ans']), 0) / frsArticles.length
              };

              suppliers.push(supplier);
            }

          });

          this.suppliers = suppliers.sort((a, b) => a.MediumCarbonImpact - b.MediumCarbonImpact);

          // Impact carbone moyen de la sélection
          this.impactCarboneMedium = e.map(item => item['Impact carbone sur 50 ans']).reduce((prev, curr) => parseFloat(prev) + parseFloat(curr), 0) / e.length;
        })
      },

      // COnversion du format HTMl vers une chaine lisible
      convertFromHtmlEntities(string) {
        return (string + "").replace(/&#\d+;/gm, function (s) {
          return String.fromCharCode(s.match(/\d+/gm)[0]);
        })
      },
    }
  }
</script>

<style scoped>
  .input-container {
      display: flex;
      justify-content: flex-start;
      column-gap: 1rem;
      margin-bottom: 1.5rem;
  }

  .input-container input {
      max-width: 8em;
  }

  .input-container button {
      background-color: #A7C13C;
  }

  .content {
      display: grid;
      grid-template-columns: 1fr auto;
      column-gap: 1rem;
  }
  .fdes-content {
      max-width: 100% !important;
  }

  @media (max-width: 1200px) {
      .content {
          grid-template-columns: 1fr;
      }
  }

  .content table * {
      font-size: 0.9rem;
  }

  h2 {
      display: inline-block;
      margin-bottom: 1.5rem;
  }

  .frs-box-container {
    width: fit-content;
    display: flex;
    flex-direction: column;
    row-gap: 0.25rem;
  }

  .frs-box {
    background: white;
    display: flex;
    justify-content: space-between;
    column-gap: 1rem;
    font-size: 0.8rem;
    padding: 0.25rem 0.5rem;
  }


    .frs-box h3 {
      font-size: 1.1rem;
      margin: 0;
    }

    .frs-box h4 {
      font-size: 0.9rem;
      font-weight: normal;
      margin: 0;
    }

  .frs-ids {
    display: flex;
    column-gap: 0.5rem;
  }

    .frs-ids .frs-initials h3 {
      display: grid;
      place-items: center;
      height: 35px;
      aspect-ratio: 1 / 1;
      line-height: 0;
      padding: 0.6rem;
      border-radius: 50%;
      background-color: #A7C13C;
      color: white;
    }

    .frs-ids > div, .frs-datas {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }

      .frs-datas > div {
        column-gap: 0.25rem;
      }

  .frs-datas {
    white-space: nowrap;
  }
</style>

<style>
  .leaf-green {
    color: rgb(39, 179, 77);
  }

  .leaf-red {
    color: rgb(223, 15, 15);
  }
</style>




// WEBPACK FOOTER //
// src/pages/BDoubleWin/RechercheFdes.vue